import { therapyPlanningAction } from 'src/redux/actions/constant';

const {
  GET_PATIENT_THERAPY_PLANNING_REQUEST_2_0,
  GET_PATIENT_THERAPY_PLANNING_SUCCESS_2_0,
  GET_PATIENT_THERAPY_PLANNING_FAILURE_2_0,
  GET_PATIENT_THERAPY_PLANNING_LOADING_2_0,
  GET_PATIENT_THERAPY_PLANNING_RESET_2_0,
} = therapyPlanningAction;

const intitialstate: any = {
  isError: false,
  errorMessage: '',
  response: null,
  loading: false,
  currentPage: -1,
  pageNumber: 0,
  totalPatient: [],
};

export const getTherapyPlanningPatientReducer_2_0 = (state = intitialstate, action: any) => {
  switch (action.type) {
    case GET_PATIENT_THERAPY_PLANNING_SUCCESS_2_0: {
      const newPageNumber = action.payload?.data?.number;
      if (state.currentPage + 1 === newPageNumber) {
        return {
          ...state,
          response: action.payload,
          loading: false,
          currentPage: newPageNumber,
          isError: false,
          errorMessage: '',
          totalPatient: [...state.totalPatient, ...action.payload?.data?.content],
          pageNumber: state.pageNumber + 1,
        };
      } else {
        return {
          ...state,
          response: action.payload,
          errorMessage: '',
          loading: false,
          isError: false,
          currentPage: newPageNumber,
          totalPatient: action.payload?.data?.content || [],
        };
      }
    }

    case GET_PATIENT_THERAPY_PLANNING_FAILURE_2_0:
      return {
        ...state,
        isError: true,
        errorMessage: action.payload,
        response: null,
        loading: false,
      };

    case GET_PATIENT_THERAPY_PLANNING_LOADING_2_0:
      return {
        // ...intitialstate,
        ...state,
        loading: true,
      };

    case GET_PATIENT_THERAPY_PLANNING_RESET_2_0:
      return intitialstate;

    default:
      return state;
  }
};
